import { Box, Button, IconButton } from "@mui/material";
import React, { useContext } from "react";
import { EnergyMeter } from "./EnergyMeter";
import { UiContext, UiContextProps } from "../contexts";
import lungsIconChapter1 from "../assets/icons/Lungs-1.png";
import lungsIconChapter2 from "../assets/icons/Lungs-2.png"
import lungsIconChapter3 from "../assets/icons/Lungs-3.png"
import lungsIconChapter4 from "../assets/icons/Lungs-4.png"
import menuIcon from "../assets/icons/menu.png";
import exitIcon from "../assets/icons/exit-icon.png";
import restartIcon from "../assets/icons/restart-icon.png";
import helpIcon from "../assets/icons/help-icon.png";
import { hoverOverride } from "./helpers";

/** Properties expected by the Footer component. 
 * @param {boolean} isProgressDisabled - When false, prevents the user from activating onProgressClicked by clicking the button.
 * @param {() => void} onProgressClicked - Callback function that triggers when the progress button is clicked.
 * @param {number} currentProgress - The current progress of the player through the game's story, passed into the progress bar.
 * @param {number} maxProgress - The maximum number of beats. The progress bar is full when currentProgress === maxProgress. */
interface FooterProps {
    isProgressDisabled: boolean;
    onProgressClicked: () => void;
    currentProgress: number,
    maxProgress: number,
    onHelpPressed: () => void;
    currentChapterIndex: number;
    onRestartGame: () => void;
    onResetBeats: () => void;
}

/**The Footer component, shown at the bottom of the app window. This provides the user with the ability to advance the story depending on the current story state, as well as
 * exist, restart, sound and help options. */
export const Footer = (props: FooterProps) => {
    const { isProgressDisabled, onProgressClicked, onHelpPressed, currentProgress, maxProgress, currentChapterIndex, onRestartGame, onResetBeats} = props;
    const { isExpanded, onExpandFooter } = useContext(UiContext) as UiContextProps;

    const onExitGame = () => {
        window.location.reload();
    }

    const onRestartPressed = () => {
        onRestartGame();
        onResetBeats();
        if (isExpanded) {
            onExpandFooter();
        }
    }

    const renderCurrentLungState = () => {
        switch(currentChapterIndex) {
            case -1:
            case 0:
            case 1:
                return (<><img src={lungsIconChapter1} alt="Lungs Stage 1"></img></>);
            case 2:
                return (<><img src={lungsIconChapter2} alt="Lungs Stage 2"></img></>);
            case 3:
                return (<><img src={lungsIconChapter3} alt="Lungs Stage 3"></img></>);
            default:
                return (<><img src={lungsIconChapter4} alt="Lungs Stage 4"></img></>);
        }
    }

    return (
        <div className="footer">
            <progress className="progress-bar" value={currentProgress} max={maxProgress}></progress>
        <div className={`footer-icon${isExpanded ? "-expanded" : ""}`}>
            <IconButton data-testid="progress-button" disabled={isProgressDisabled} size="small" onClick={onProgressClicked} sx={hoverOverride}>
                {renderCurrentLungState()}
            </IconButton>
        </div>
            <div className='footer-options'>
                <EnergyMeter/>
                <div className='menu-icon'>
                    <IconButton onClick={onExpandFooter}>
                        <img src={menuIcon} alt="Menu button"/>
                    </IconButton>
                </div>
            </div>
        {isExpanded &&
            <div className="expanded-options">
                <Box display="flex" textAlign="inherit" justifyContent="inherit" flexDirection="inherit">
                    <Button variant="text" onClick={onExitGame}  size="small" color="inherit" sx={{justifyContent: "inherit", textTransform: "inherit" }}>
                        <img src={exitIcon} alt="Exit"></img>
                        <p>Exit Game</p>
                    </Button>
                    <Button variant="text" onClick={onRestartPressed} size="small" color="inherit" sx={{justifyContent: "inherit", textTransform: "inherit"}}>
                        <img src={restartIcon} alt="Reset"></img>
                        <p>Restart</p>
                    </Button>
                    <Button variant="text" onClick={onHelpPressed} size="small" color="inherit" sx={{justifyContent: "inherit", textTransform: "inherit",  }}>
                        <img src={helpIcon} alt="Help"></img>
                        <p>Help</p>
                    </Button>
                </Box>
            </div>
            }
    </div>
    )
}